import { render, staticRenderFns } from "./ProgrammingResult.vue?vue&type=template&id=36a154ae&scoped=true&"
import script from "./ProgrammingResult.vue?vue&type=script&lang=js&"
export * from "./ProgrammingResult.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammingResult.vue?vue&type=style&index=0&id=36a154ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a154ae",
  null
  
)

export default component.exports